// extracted by mini-css-extract-plugin
export default {"Table":"request_Table__ADLdO"};